export default __webpack_public_path__ + "static/media/cooking-wok.598ba6d2.mp4";